<template>
    <div name="search" class="search" v-if="result === 0">
        <!-- <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/search/1.png" />
            <div class="button1" @click="goHome">

            </div>
            <div class="button2" @click="goResult">

            </div>
        </div>
        
        <img class="image" src="../../assets/showcase/xi/search/2.png" @click="goResult" />
        <img class="image" src="../../assets/showcase/xi/search/3.png" />
        <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/search/4_1.png" @click="tabClick" />
        <img v-else class="image" src="../../assets/showcase/xi/search/4_2.png" @click="tabClick"/>
        <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/search/5_1.png" @click="goList"/>
        <img v-else class="image" src="../../assets/showcase/xi/search/5_2.png" @click="goList"/> -->
        <div class="distribute-button-area">
            <img class="back-image" src="../../assets/showcase/preview/department/1.png" >
            <div class="header-back-button" @click="goHome"></div>
            <div class="header-search-button" @click="goResult"></div>
        </div>
        
        <div class="bottom" v-if="tab === 0">
            <img class="image" src="../../assets/showcase/preview/department/2_1.png" @click="tabClick">
            <img class="image" src="../../assets/showcase/preview/department/3_1.png"  @click="goList">
            <img class="image" src="../../assets/showcase/preview/department/4.png"  @click="goResult">
        </div>
        <div class="bottom" v-else>
            <img class="image" src="../../assets/showcase/preview/department/2_2.png" @click="tabClick">
            <img class="image" src="../../assets/showcase/preview/department/3_2.png"  @click="goList">
            <img class="image" src="../../assets/showcase/preview/department/4.png"  @click="goResult">
        </div>    
    </div>
    <div v-else class="search" >
        <img class="image" src="../../assets/showcase/xi/search/map_1.png" @click="resultChange(0)" />
        <img class="image" src="../../assets/showcase/xi/search/map_2.png" />
        <div style="margin-bottom: calc(100vw * 60 / 375);  bottom: calc(100vw * 57 / 375); position: fixed; width: calc(100% - 12.4px - 7vw); display: flex;flex-direction: column; left: 4vw">
            <img class="image" src="../../assets/showcase/xi/search/map_3.png"  />
            <img class="image" src="../../assets/showcase/xi/search/map_4.png" @click="goBooking"/>
        </div>

    </div>
</template>

<script>
export default {
    name: 'search',
    data: function()
    {
        return {
            tab: 0,
            result: 0
        }
    },
    methods: {
        tabClick: function()
        {
            this.tab = this.tab === 0 ? 1 : 0;
            this.reset();
        },
        goResult: function()
        {
            this.result = 1;   
            this.reset();
        },
        resultChange: function(result)
        {
            this.reset = result;
            this.reset();
        },
        goBooking: function()
        {
            this.$emit('goBookingTab')
        },
        goHome: function()
        {
            this.$emit('goHomeTab')
        },
        goList: function()
        {
            this.$emit('goListTab')
        },
        reset: function()
        {
            this.$emit('resetCount')
        }
    }
}
</script>

<style scoped>
    .search {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        width: 100%;
        position: relative;
    }
    .button1 {
        position: absolute;
        /* background: red; */
        height: 100%;
        width: 10vw;
        top: 0;
    }
    .button2 {
        position: absolute;
        /* background: blue; */
        height: 100%;
        width: 65vw;
        left: 15vw;
        top: 0;
    }
        .distribute-button-area {
        display: flex;
        position: relative;
        width: 100%;
        aspect-ratio: 7;
    }
    .back-image {
        position: absolute;
        width: 100%;
    }
    .header-back-button {
        width: 12%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .header-search-button {
        width: 82%;
        height: 100%;
        top: 0;
        left: 12%;
        z-index: 1;
    }
    .bottom {
        margin-bottom: calc(100vw * 120 / 375);
        background: #FFF;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Search.vue